import { gql } from '../__generated__';

export const COMPANIES_INDUSTRIES_QUERY = gql(`
  query CompaniesIndustries($limit: Int) {
    companiesIndustries(limit: $limit, order: TOTAL) {
      collection {
        industry {
          id
          localizationValue
        }
        total
      }
    }
  }
`);
